import { useApi } from '@backstage/core-plugin-api';
import useAsync from 'react-use/lib/useAsync';
import { llmProxyKeysApiRef } from './api/LlmProxyKeysClient';

export function useLlmProxyKeysConfig() {
  const api = useApi(llmProxyKeysApiRef);
  const { value, loading, error } = useAsync(() => api.getConfig(), [api]);
  return { config: value, loading, error };
}

export function useLlmProxyKeysApi() {
  return useApi(llmProxyKeysApiRef);
}
